<template>
    <div>
        <!-- 复用 tagsView 缓存体系：让第三层叶子页面在切换时保留数据 -->
        <keep-alive :include="cachedViews">
            <router-view :key="key" />
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: 'Empty',
    computed: {
        cachedViews() {
            return this.$store.getters.cachedViews
        },
        key() {
            return this.$route.path
        }
    }
}
</script>